import { Injectable } from "@angular/core";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { environment } from "../../environments/environment";
import { notificationService } from "../Layout/Components/header/elements/package-notification/package-notification.service";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  constructor(
    private notificationService: notificationService,
    private router: Router,
  ) {}
  app = initializeApp(environment.firebase);
  messaging = getMessaging(this.app);
  ICON_URL = "https://admin.imtransporter.com/assets/images/logo.png";

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();

      if (permission !== "granted") {
        console.log("Notification permission denied");
        return;
      }

      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
      });

      if (token) {
        console.log("FCM Token:", token);
        const data = { fcmToken: token };
        this.notificationService.saveFcmToken(data).subscribe(
          (response) => {
            console.log("Token saved successfully:", response);
          },
          (error) => {
            console.error("Error saving token:", error);
          },
        );
      }
    } catch (err) {
      console.error(err);
    }
  }

  notifications: any[] = [];
  unreadCount = 0;
  getNotifications() {
    this.notificationService.getNotifications().subscribe({
      next: (res: any) => {
        this.notifications = res.data || [];
        this.unreadCount = this.notifications.length;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  listen() {
    onMessage(this.messaging, (payload: any) => {
      console.log("Foreground Message:", payload);
      this.getNotifications();
      // ✅ Send to service worker to show notification
      // so notificationclick handler works correctly
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(
          payload.notification?.title || "Notification",
          {
            body: payload.notification?.body || "",
            icon: this.ICON_URL,
            data: payload.data || {},
          },
        );
      });
    });
  }
}
